exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-header-v2 .title-desc-container{flex:1;overflow:hidden}.cap-header-v2 .cap-header-v2-description{padding-top:.285rem}\n", ""]);

// exports
